import BaseModelDropZoneGrid from "@/models/BaseModelDropZoneGrid.js";
import BaseModelDropZoneToolBar from "@/models/BaseModelDropZoneToolBar.js";

export const DropZoneGridConfig = {
	list: BaseModelDropZoneGrid.list,
	grid: BaseModelDropZoneGrid.grid,
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			editable: false,
			readOnly: true
		},
		File: {
			class: 'value',
			dataName: 'File',
			type: 'string',
			title: 'File Name',
			width: 150,
			hidden: false,
			readOnly: true
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'Program/Id',
			type: 'number',
			title: 'Program ID',
			width: 100,
			hidden: true,
			readOnly: false,
			editable: false
		},
		ProgramTitle: {
			class: 'dropdown',
			dataName: 'Program/Title',
			type: 'dropdown',
			dropdown: true,
			//source:'EntityTypeOptions',
			title: 'Program',
			width: 150,
			hidden: false,
			readOnly: true
		},
		PartnerId: {
			class: 'lookup',
			dataName: 'Partner/Id',
			type: 'number',
			title: 'Partner ID',
			width: 100,
			hidden: true,
			readOnly: false,
			editable: false
		},
		PartnerTitle: {
			class: 'lookup',
			dataName: 'Partner/FullName',
			type: 'dropdown',
			dropdown: true,
			//source:'PartnerTypeOptions',
			title: 'Partner',
			width: 150,
			hidden: false,
			readOnly: true
		},
		DocumentType: {
			class: 'choice',
			dataName: 'DocumentType',
			type: 'string',
			title: 'Document Type',
			dropdown: true,
			width: 150,
			hidden: false,
			readOnly: false
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'dropdown',
			dropdown: true,
			title: 'DocumentLevel',
			width: 120,
			hidden: false
		},
		Status: {
			class: 'status',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: false,
			readOnly: true,
			editable: false
		},
		BatchGUID: {
			class: 'value',
			dataName: 'BatchGUID',
			type: 'number',
			title: 'Batch Id',
			width: 100,
			hidden: true,
			editable: false,
			readOnly: false
		}
	}
}

export const DropZoneGridToolBarConfig = {

	items: BaseModelDropZoneToolBar.items,
	DisableBaseDefaultItems: BaseModelDropZoneToolBar.DisableBaseDefaultItems
}